export default __webpack_public_path__ + "static/media/reffer.78126ece.svg";